import useStore from "core/custom-hooks/useStore";

import { selfServiceUrl } from "core/common/constants/env";
import * as Utils from "core/common/utils";
import SiteIds from "pages/BusinessOverview/constants/SiteIds";

const useSelfService = () => {
    const { state, dispatch, authRepository } = useStore();
    const { business } = state;

    const action = async () => {
        Utils.loadingWrapper(dispatch, async () => {
            const key = await authRepository.getSelfServiceApiKey();

            if (Utils.isSuccessfulRequest(dispatch, key?.data, true)) {
                const encoded = encodeURIComponent(key?.data?.data?.api_key);

                const url = `${selfServiceUrl}?business=${business?.business_id}&biztoken=${encoded}`;
                console.log("link", url);
                window.location.assign(url);
            }
        });
    };

    const condition = business?.sites?.filter(i=> i.name === SiteIds[3] && i.primaryTags.length > 0)?.length > 0 ; //business && business.is_dyi;

    return {condition}//{ action, condition }
};

export default useSelfService;
